<template>
  <h6>About</h6>
</template>

<script>
export default {
  name: "test",
  data() {
    return {
      test: true,
    };
  },
  props: {
    address: String,
    balance: Number,
  },
  methods: {
    tester: function () {
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>